import { helper } from '@ember/component/helper';

/**
 * Genera un ID concatenando i parametri
 */
var generateId = helper(params => Array.isArray(params) && params.length > 0 ? params.join('') : null);

export { generateId as default };
//# sourceMappingURL=generate-id.js.map
